import React, { HTMLProps } from 'react'
import { FontSizeProps, TLengthStyledSystem } from 'styled-system'
import CSS from 'csstype'
import { SystemProps } from '../../new/theme/system'
import { Text } from '../../new/core-components/text'
import { Box } from '../../new/core-components/box'
import { Loader } from '../loader'
import { Theme } from '../../new/theme'
import { ThemeFontSizes } from '../../new/theme/types'
import { ButtonStyled } from './ButtonStyled'

interface BaseButtonProps {
  children?: React.ReactNode
  className?: string
  'data-test-id'?: string
  endIcon?: React.ReactNode
  loading?: boolean | { delay?: number }
  renderRawChildren?: boolean
  startIcon?: React.ReactNode
}

type ButtonHTMLType = 'submit' | 'button' | 'reset'

type NativeButtonProps = {
  htmlType?: ButtonHTMLType
  onClick?: React.MouseEventHandler<HTMLElement>
} & BaseButtonProps &
  Omit<React.ButtonHTMLAttributes<any>, 'type' | 'onClick'>

/** @deprecated - Props of deprecated {@link Button} component */
export type Props = Omit<SystemProps, 'fontSize'> &
  NativeButtonProps & { textDecoration?: CSS.Property.TextDecoration } & HTMLProps<
    HTMLAnchorElement | HTMLButtonElement
  > &
  FontSizeProps<Theme, ThemeFontSizes | CSS.Property.FontSize<TLengthStyledSystem>>

/**
 * @deprecated - If it matches visually use the Button component from
 *   `@chilipiper/design-system/src/new` otherwise it's old design or an incorrect usage
 */
export const Button = ({
  color,
  children,
  htmlType,
  startIcon,
  endIcon,
  loading,
  disabled,
  renderRawChildren,
  onClick,
  ref,
  ...other
}: Props) => {
  const textOffset = children ? 2 : 0

  return (
    <ButtonStyled
      ref={ref}
      display='flex'
      alignItems='center'
      justifyContent='center'
      textDecoration='none'
      m={0}
      py={0}
      px={4}
      h={8}
      borderRadius={8}
      bg='white'
      onClick={onClick}
      boxShadow='border/section'
      disabled={disabled || loading}
      type={htmlType}
      color={renderRawChildren ? color : undefined}
      cursor='pointer'
      {...other}
    >
      {startIcon && !loading && <Box mr={textOffset}>{startIcon}</Box>}
      {loading && (
        <Box mr={textOffset}>
          <Loader size={4} color={color} />
        </Box>
      )}
      {children &&
        (renderRawChildren ? (
          children
        ) : (
          <Text
            textStyle='button'
            color={disabled ? 'fg/disabled' : color}
            fontSize={other.fontSize ?? 14}
          >
            {children}
          </Text>
        ))}
      {endIcon && <Box ml={2}>{endIcon}</Box>}
    </ButtonStyled>
  )
}
